<script setup>
import { defineProps } from 'vue';

defineProps({
    campaign: Object,
    client: String,
    workflow: Object,
    agent: String,
})
</script>
<template>
    <div class="session-summary">
        <ul>

            <li>

                <span>
                    Organisation
                </span>

                {{ client }}

            </li>

            <li>

                <span>
                    Agent:
                </span>

                {{ agent }}

            </li>

            <li>

                <span>
                    Campaign:
                </span>

                {{ campaign.name }}

            </li>

            <li>

                <span>
                    Workflow:
                </span>

                {{ workflow.name }}

            </li>

            <li>

                <span>
                    Type:
                </span>

                {{ workflow.serviceType }}

            </li>

            <li v-if="workflow.countryCode">

                <span>
                    Country:
                </span>

                {{ workflow.countryCode }}

            </li>

        </ul>

        <p>
            {{ campaign.description }}
        </p>

        <hr>
    </div>

</template>
<style scoped>
.session-summary {
    text-align: center;
    margin-right: auto;
    margin-left: auto;
    padding-left: 15px;
    padding-right: 15px;
}

ul {
    list-style: none;
}

.session-summary ul>li {
    display: inline-block;
    width: auto;
    border-right: 1px solid #dddddf;
    padding-right: 10px;
    margin: 0 10px 15px 0;
    font-weight: 500;
}

.session-summary ul>li:last-of-type {
    border-right: 0;
    padding-right: 0;
    margin-right: 0;
}

.session-summary ul>li span {
    color: #848484;
    font-weight: 400;
}
</style>